import { useParams, Link } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import { getUrl } from '../../App';
import styles from './LogListView.module.css';
import LogCard from "../LogCard/LogCard.jsx";
import SkeletonCard from '@shared/components/SkeletonCard/SkeletonCard';


const fetch_logs = async (id) => {
    // FIXME: only get logs for a game
    const response = await fetch(`${getUrl()}/api/logs/?game=${id}`,{credentials: 'include', });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
}



function LogListView() {
     // get the log id from the url
    const { id } = useParams();

    const logs = useQuery({
        queryKey: ['logs', id], queryFn: () => fetch_logs(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });
    if (logs.isError) {
        return <div>Error fetching logs: {logs.error.message}</div>;
    }
   
    return (
         <div className={styles.view_content}>
        
            <div className="panel-header">
                <h3>LogView</h3>
            </div>
            <div className={styles.projects_section}>
                <div className={`${styles.project_boxes} ${styles.jsGridView}`}>
                    {logs.isLoading ? (
                    <>
                        <SkeletonCard />
                        <SkeletonCard />
                        <SkeletonCard />
                    </>
                ) : logs.data.length > 0 ? (
                    logs.data.sort((a, b) => {
                                // Example: sort by 'player_number' in ascending order
                                if (a.player_number < b.player_number) return -1;
                                if (a.player_number > b.player_number) return 1;
                                return 0;

                            }).map((log) => (
                        <Link to={`/logs/${log.id}`} key={log.id}>
                        <LogCard log={log} /> 
                        </Link>
                    ))
                ) : (
                    <div className={styles.emptyState}>
                        No events found
                    </div>
                )}
                </div>
            </div>
        </div>
    );
}

export default LogListView;